/** Instagram / TikTok handle: letters, digits, dot, underscore (max. 30). */
const SOCIAL_USERNAME_PATTERN = /^@?[A-Za-z0-9._]{1,30}$/;

export function isValidSocialUsername(value: string): boolean {
  return SOCIAL_USERNAME_PATTERN.test(value.trim());
}
